import { configure } from "mobx";

/**
 * MobX strict mode configuration for better debugging
 * Following mobx-strict-mode rule
 */
export function configureMobX(): void {
    // Enable strict mode in development for better debugging
    if (import.meta.env.DEV) {
        configure({
            // Require actions for state modifications
            enforceActions: "always",
            // Warn if computed values are accessed outside reactive context
            computedRequiresReaction: true,
            // Warn if reactions don't access any observables
            reactionRequiresObservable: true,
            // Warn if observables are accessed outside reactive context
            observableRequiresReaction: false, // Set to false to allow console.log debugging
            // Don't swallow errors in reactions
            disableErrorBoundaries: false,
        });
    } else {
    // Production configuration - less strict for performance
        configure({
            enforceActions: "always",
            computedRequiresReaction: false,
            reactionRequiresObservable: false,
            observableRequiresReaction: false,
            disableErrorBoundaries: false,
        });
    }
}

